import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDragDotsSvg } from "./IconDragDotsSvg.mjs";
const IconDragDots = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDragDotsSvg, ...iconProps });
};
export {
  IconDragDots
};
